module.exports = __webpack_public_path__ + "static/media/dottie-iterations.0438dab6.png";